function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    focusable: "false"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.35,102.14c.46,23.02-2.03,41.97-17.6,60.02-15.57,18.05-39.26,28.42-62.95,28.42-47.83,0-87.54-39.7-87.54-87.53S42.98,14.6,91.94,14.6c29.78,0,53.92,13.32,71.97,36.78l-13.76,12.85c-14.21-20.08-33.39-32.03-58.44-32.03-38.81,0-69.49,32.72-69.49,71.06,0,18.06,7.22,35.2,19.85,48.06,12.41,12.42,30.45,21.67,48.28,21.67,29.56,0,60.69-21.67,60.69-53.25h-61.13v-17.6h81.44ZM298.29,9.42l-78.52,178.23h20.76l20.53-48.28h72.65l20.08,48.28h20.98L298.29,9.42Zm-29.55,112.35l29.09-68.14,28.44,68.14h-57.53Zm190.56,65.88h-18.95V17.53h18.95v170.12Zm107.92-17.59h78.18v17.59h-97.13V17.53h18.94v152.52ZM696.24,20.7l-25.71,57.53-12.19-4.74,21.21-58.89,16.69,6.09Zm78.84,85.51c-2.49-5.63-7.9-10.83-14.44-10.83s-13.09,4.96-13.09,11.73c0,9.7,12.19,13.31,24.6,18.5,12.4,5.19,24.59,12.63,24.59,30.46,0,20.08-16.25,34.51-35.87,34.51-17.82,0-31.82-10.15-37.45-26.84l16.02-6.78c4.51,9.93,9.7,16.92,21.66,16.92,9.7,0,17.15-6.54,17.15-16.24,0-23.69-47.83-15.57-47.83-48.96,0-17.83,14.44-30.01,31.59-30.01,12.18,0,23.46,8.57,28.2,19.63l-15.11,7.9Z",
    style: {
      fill: "#ce132d",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo-red.cdcb17fb86a3913559c0ebf7ba6de7ef.svg";
export { ForwardRef as ReactComponent };